import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommPlan } from '../../models/commission/comm-plan.model';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { NotificationService } from 'src/app/service/notification.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { GlobalService } from 'src/app/service/global.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApprovalFlowService } from '../approval-flow-models/approval-flow.service';
import { WorkFlowMessageModel } from 'src/app/models/commissionsummary/workflowmessage.model';
import { WorkflowTicket } from '../approval-flow-models/workflow-ticket.model';
import {
  enrichCommissionReportPayrollMonth,
  clearCommissionReportApprovalsNavigationContext,
  readCommissionReportApprovalsNavigationContext
} from '../../shared/utils/commission-report-payroll.util';
import { formatDate } from '@angular/common';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import * as XLSX from 'xlsx';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { MatDialog } from '@angular/material/dialog';
import { CommissionReportPreviewModalComponent } from './comm-preview-modal/comm-preview-modal.component';


@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.css']
})
export class ApprovalsComponent implements OnInit {
  approvalsDataModel = new WorkFlowMessageModel();
  approvalsSearchModel = new WorkFlowMessageModel();
  approvalsData: WorkflowTicket[] = [];
  excelApprovalsData: WorkflowTicket[] = [];
  approvalsBackupData: WorkflowTicket[] = [];
  approvalsData1: WorkflowTicket[] = [];

  selctedTickets: WorkflowTicket[] = [];
  commPlansList: CommPlan[] = [];
  salesChannelsList: CommPlan[] = [];
  salesChannels: string[] = [];
  editableHeader: boolean = false;
  isReplicate: boolean = true;
  isUpdate: boolean = true;
  selectedSc: string = 'All';
  filterScValue: string = '';
  radioCheck: boolean = false
  count: number = 0;
  favoriteSeason: string = null;
  mySalesChannelSet = new Set<string>();
  currentCheckedValue = null;
  Languages: string[] = [];
  payrollCalender: string[] = [];
  permissionCheck: any;
  isAccessDisabled: boolean = false;
  isChecked: boolean = false;

  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];
  columnsExcelData: any;

  @ViewChild('table') table: ElementRef;

  ordersTableColumns1: TableColumn[];
  columnsData: any;
  pageColumnsData: any;
  actions: any;
  checkbox: any;
  actionButtons: any;
  kpiType: string;
  clickedKpiType: string;
  selectedcommplanid: any;
  selectedSalesChannel: any;
  selectedDisputeType: string = "";
  disputeTypes: string[] = [];
  showRemoveChargeback: boolean = true;
  edate: any;
  nrSelect: string = "";

  contentMessage: WorkFlowMessageModel[];
  contentMsgData: any;
  displayedColumns = [];
  displayedData = [];
  checkedactiveall: boolean = false;
  checkedactive: boolean = false;

  menusFilter: UserManagementModel[] = [];
  updateTicket: WorkflowTicket;
  isView: boolean = true;

  removeStatus: string = "";

  str1: string = "";
  str2: string = "";
  selectedValue: string = "all";

  isDisabled: boolean = false;
  isSalesRep: boolean = true;
  isSalesRepDropdown: boolean = true;
  isMissingTrans: boolean = true;

  actionsextracol: any;

  fdt: string = "1111-11-11";
  tdt: string = "1111-11-11";

  private pendingCommissionReportTrackingId: string | null = null;

  constructor(private notificationService: NotificationService, private exportExcelService: ExportExcelService, private globalService: GlobalService, private httpService: HttpClient, private approvalFlowService: ApprovalFlowService, private dialog: MatDialog) { globalService._disableBackButton(); }

  private previousDates: { fdt: string; tdt: string } | null = null;

  ngOnInit(): void {

    this.approvalsSearchModel.fromdt = new Date().toISOString().substring(0, 10); // Formats to YYYY-MM-DD
    this.approvalsSearchModel.todt = new Date().toISOString().substring(0, 10); // Formats to YYYY-MM-DD

    this.approvalsSearchModel.stat = "all";
    this.nrSelect = "Pending";
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('approvals');
    if (this.isAccessDisabled) {
      //this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
    }
    //console.log(localStorage.getItem('CURRENT_USERROLE_SESSION'));
    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
      this.isDisabled = true;
      this.isSalesRep = false;
      this.isSalesRepDropdown = false;
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Supervisor") {
      this.isSalesRepDropdown = false;
    } else {
      this.isDisabled = false;
      this.isSalesRep = true;
      this.isSalesRepDropdown = true;
    }
  }

  public init() {
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.loadDisputeTypes();
    this.getSalesChannels();

    this.getApprovalsData(this.approvalsSearchModel.fromdt, this.approvalsSearchModel.todt);
  }

  loadDisputeTypes() {
    this.disputeTypes = [
      'My Approvals',
      'Commission Report'
    ];
  }

  filterByDates() {
    console.log("filterData() called");
    // console.log(this.approvalsSearchModel.fromdt);
    // console.log(this.approvalsSearchModel.todt);
    // console.log(this.approvalsSearchModel.saleschannel);
    // console.log(this.approvalsSearchModel.commplan);
    // console.log(this.approvalsSearchModel.stat);

    //this.approvalsBackupData = JSON.parse(JSON.stringify(this.approvalsData1));

    if (this.approvalsSearchModel.fromdt) {
      if (!this.approvalsSearchModel.todt) {
        this.notificationService.sendNotification(NotificationType.ERROR, "Please select To Date");
      }
    }

    if (this.approvalsSearchModel.todt) {
      if (!this.approvalsSearchModel.fromdt) {
        this.notificationService.sendNotification(NotificationType.ERROR, "Please select From Date");
      }
    }

    console.log("Inside ELSE");
    console.log(this.approvalsBackupData.length);

    if (this.approvalsSearchModel.fromdt) {
      if (this.approvalsSearchModel.todt) {
        console.log("Inside Dates IF");
        this.fdt = this.approvalsSearchModel.fromdt;
        this.tdt = this.approvalsSearchModel.todt;

        console.log(this.fdt);
        console.log(this.tdt);
        //this.approvalsData = this.approvalsBackupData.filter(comm => comm.created_dt >= this.approvalsSearchModel.fromdt && comm.created_dt <= this.approvalsSearchModel.todt);
        this.getApprovalsData(this.fdt, this.tdt);
      }
    } else {
      console.log("Inside Dates ELSE");
      if (!this.approvalsSearchModel.fromdt) {
        if (!this.approvalsSearchModel.todt) {
          this.fdt = "1111-11-11";
          this.tdt = "1111-11-11";

          this.getApprovalsData(this.fdt, this.tdt);
        }
      }

    }

  }

  getApprovalsData(fdt: string, tdt: string) {
    console.log("getApprovalsData() called");

    // Check if the selected dates match the previous dates
    if (
      this.previousDates &&
      this.previousDates.fdt === this.fdt &&
      this.previousDates.tdt === this.tdt
    ) {
      console.log("Skipping API call, same dates provided.");
      this.filterData();
      // return;
    } else {
      console.log("Running API call, diff dates provided.");
      this.approvalsData = null;
      this.approvalsData1 = null;
      // Update previous dates and call the service
      this.previousDates = { fdt, tdt };

      this.approvalFlowService.getApprovalsData(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'), localStorage.getItem('CURRENT_USERROLE_SESSION'), 'all', fdt, tdt)
        .subscribe((response: WorkflowTicket[]) => {
          this.approvalsData = enrichCommissionReportPayrollMonth(response);
          //console.log(JSON.stringify(this.approvalsData));
          this.approvalsData1 = JSON.parse(JSON.stringify(response));

          // this.approvalsData = this.approvalsData.filter(comm => comm.status.startsWith("Pending"));

          this.approvalsData = this.approvalsData.sort((a: any, b: any) => b.corp - a.corp);

          this.approvalsData = this.approvalsData.sort((a, b) => (a.cdt > b.cdt) ? -1 : 1);
          this.approvalsBackupData = JSON.parse(JSON.stringify(this.approvalsData));

          this.applyCommissionReportNavigationContext();
          this.filterData();
          // this.displayApprovalData();

        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }


  }

  getApprovalsAppRejData(fdt: string, tdt: string) {
    console.log("getApprovalsData() called");


    console.log("Running API call, diff dates provided.");
    this.approvalsData = null;
    this.approvalsData1 = null;
    // Update previous dates and call the service
    this.previousDates = { fdt, tdt };

    this.approvalFlowService.getApprovalsData(localStorage.getItem('CURRENT_EMPLOYEEID_SESSION'), localStorage.getItem('CURRENT_USERROLE_SESSION'), 'all', fdt, tdt)
      .subscribe((response: WorkflowTicket[]) => {
        this.approvalsData = enrichCommissionReportPayrollMonth(response);
        console.log(this.approvalsData.length);
        this.approvalsData1 = JSON.parse(JSON.stringify(response));

        // this.approvalsData = this.approvalsData.filter(comm => comm.status.startsWith("Pending"));

        this.approvalsData = this.approvalsData.sort((a: any, b: any) => b.corp - a.corp);

        this.approvalsData = this.approvalsData.sort((a, b) => (a.cdt > b.cdt) ? -1 : 1);
        this.approvalsBackupData = JSON.parse(JSON.stringify(this.approvalsData));

        this.applyCommissionReportNavigationContext();
        this.filterData();

        // this.displayApprovalData();

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });



  }


  filterData() {
    console.log("Inside filterData()");

    this.approvalsData = this.approvalsBackupData;


    console.log(this.selectedSalesChannel);
    console.log(this.selectedcommplanid);

    console.log(this.approvalsData);


    if (this.selectedSalesChannel) {
      console.log("Inside SC");
      this.approvalsData = this.approvalsData.filter(comm => comm.sales_channel === this.selectedSalesChannel);
    }
    console.log("SC length: " + this.approvalsData.length);

    if (this.selectedcommplanid) {
      console.log("Inside COMMPLAN");
      console.log("Inside COMMPLAN length: " + this.approvalsData.length);
      this.approvalsData = this.approvalsData.filter(comm => comm.complanid.toString() === this.selectedcommplanid.toString());
    }
    console.log("COMMPLAN length: " + this.approvalsData.length);

    if (this.selectedDisputeType) {
      console.log("Inside DISPUTETYPE");
      if (this.selectedDisputeType === 'My Approvals') {
        this.approvalsData = this.approvalsData.filter(comm => comm.disputeType !== 'Commission Report');
      } else {
        this.approvalsData = this.approvalsData.filter(comm => comm.disputeType === this.selectedDisputeType);
      }
    }
    console.log("DISPUTETYPE length: " + this.approvalsData.length);

    if (!this.approvalsSearchModel.stat) {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please select status");
    } else {
      console.log("Inside stat");
      if (this.approvalsSearchModel.stat === "all") {
        this.approvalsData = this.approvalsData;
      } else {
        this.approvalsData = this.approvalsData.filter(comm => comm.status === this.approvalsSearchModel.stat);
      }
    }

    if (this.pendingCommissionReportTrackingId) {
      const trackingId = this.pendingCommissionReportTrackingId;
      this.approvalsData = this.approvalsData.filter(
        comm => (comm.trackingId || comm.tracking_id) === trackingId
      );
      this.pendingCommissionReportTrackingId = null;
    }

    console.log(this.approvalsData.length);
  }

  getSalesChannels() {
    this.approvalFlowService.getSalesChannels()
      .subscribe((response: CommPlan[]) => {
        this.salesChannelsList = response;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getCommissionPlans() {
    console.log(this.selectedSalesChannel);
    if (this.selectedSalesChannel) {
      this.approvalFlowService.getCommissionPlans(this.selectedSalesChannel)
        .subscribe((response: CommPlan[]) => {
          this.commPlansList = response;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    } else {
      this.commPlansList = [];
    }
  }


  autoTriggerFilter() {
    if (this.approvalsBackupData && this.approvalsBackupData.length > 0) {
      this.filterData();
    }
  }

  getSc(value: any) {
    this.selectedSalesChannel = value;
    console.log(this.selectedSalesChannel);

    this.selectedcommplanid = "";

    //this.filterApprovalsData(this.nrSelect);

    this.getCommissionPlans();
    this.autoTriggerFilter();
  }

  getCommPlan(value: any) {
    this.selectedcommplanid = value;
    console.log(this.selectedcommplanid);
    this.autoTriggerFilter();
  }

  getStatus(value: any) {
    this.approvalsSearchModel.stat = value;
    console.log(this.approvalsSearchModel.stat);
    this.autoTriggerFilter();
  }

  getDisputeType(value: any) {
    this.selectedDisputeType = value;
    console.log(this.selectedDisputeType);
    this.loadColumnsForDisputeType();
    this.autoTriggerFilter();
  }

  loadColumnsForDisputeType() {
    if (this.selectedDisputeType === 'Commission Report') {
      this.ordersTableColumns1 = this.columnsData.ApprovalsDataCommissionReport;
      this.showRemoveChargeback = false;
    } else {
      // 'My Approvals' or empty selection - show standard columns
      this.ordersTableColumns1 = this.columnsData.ApprovalsData;
      this.showRemoveChargeback = true;
    }
  }

  private applyCommissionReportNavigationContext(): void {
    const context = readCommissionReportApprovalsNavigationContext();
    if (!context.trackingId) {
      return;
    }

    if (context.disputeType) {
      this.selectedDisputeType = context.disputeType;
      this.loadColumnsForDisputeType();
    }

    if (context.salesChannel) {
      this.selectedSalesChannel = context.salesChannel;
      this.approvalsSearchModel.saleschannel = context.salesChannel;
      this.getCommissionPlans();
    }

    if (context.commPlanId) {
      this.selectedcommplanid = context.commPlanId;
      this.approvalsSearchModel.commplan = context.commPlanId;
    }

    this.approvalsSearchModel.stat = 'all';
    this.nrSelect = 'all';
    this.pendingCommissionReportTrackingId = context.trackingId;

    clearCommissionReportApprovalsNavigationContext();
  }


  approvalCheck() {

    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
      this.approveWorkflow();
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
      this.approveWorkflow();
    } else {
      this.approveWorkflow();
    }
  }

  rejectCheck() {
    if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "ADMIN") {
      this.rejectWorkflow();
    } else if (localStorage.getItem('CURRENT_USERROLE_SESSION') === "Sales Representative") {
      this.rejectWorkflow();
    } else {
      this.rejectWorkflow();
    }
  }



  public approveWorkflow() {
    if (this.checkedactiveall === true) {
      this.approvalsData[0].status = 'Approved';
      this.approvalsData[0].loggedinrole = localStorage.getItem('CURRENT_USERROLE_SESSION');
      this.approvalsData[0].approved_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.approvalsData[0].updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.approvalsData[0].update_dt = new Date();

      for (let com of this.approvalsData) {
        if (!com.comments) {
          this.notificationService.sendNotification(NotificationType.ERROR, "Please enter comments");
          return false;
        }
      }

      console.log(this.approvalsData);

      this.approvalFlowService.approveRejectWorkflow(this.approvalsData)
        .subscribe(response => {
          //this.getAllApprovalsData();

          this.getApprovalsAppRejData(this.approvalsSearchModel.fromdt, this.approvalsSearchModel.todt);
          this.notificationService.sendNotification(NotificationType.SUCCESS, "Approved Successfully");
          this.selctedTickets = [];
          this.checkedactive = false;
          this.checkedactiveall = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    } else {
      if (this.selctedTickets.length === 0) {
        this.notificationService.sendNotification(NotificationType.ERROR, "Please select records");
      } else {
        this.selctedTickets[0].status = 'Approved';
        this.selctedTickets[0].loggedinrole = localStorage.getItem('CURRENT_USERROLE_SESSION');
        this.selctedTickets[0].approved_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
        this.selctedTickets[0].updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
        this.selctedTickets[0].update_dt = new Date();



        for (let com of this.selctedTickets) {
          console.log(com);
          if (!com.comments) {
            this.notificationService.sendNotification(NotificationType.ERROR, "Please enter comments");
            return false;
          }
        }

        console.log(this.selctedTickets);

        this.approvalFlowService.approveRejectWorkflow(this.selctedTickets)
          .subscribe(response => {
            //this.getAllApprovalsData();

            console.log(JSON.stringify(response));

            this.notificationService.sendNotification(NotificationType.SUCCESS, "Approved Successfully");
            this.getApprovalsAppRejData(this.approvalsSearchModel.fromdt, this.approvalsSearchModel.todt);

            this.selctedTickets = [];
            this.checkedactive = false;
            this.checkedactiveall = false;
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          })
      }
    }
  }

  public rejectWorkflow() {
    if (this.checkedactiveall === true) {
      this.approvalsData[0].status = 'Rejected';
      this.approvalsData[0].loggedinrole = localStorage.getItem('CURRENT_USERROLE_SESSION');
      this.approvalsData[0].approved_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.approvalsData[0].updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.approvalsData[0].update_dt = new Date();

      for (let com of this.approvalsData) {
        if (!com.comments) {
          this.notificationService.sendNotification(NotificationType.ERROR, "Please enter comments");
          return false;
        }
      }

      this.approvalFlowService.approveRejectWorkflow(this.approvalsData)
        .subscribe(response => {
          //this.getAllApprovalsData();
          this.notificationService.sendNotification(NotificationType.SUCCESS, "Rejected Successfully");
          this.getApprovalsAppRejData(this.approvalsSearchModel.fromdt, this.approvalsSearchModel.todt);

          this.selctedTickets = [];
          this.checkedactive = false;
          this.checkedactiveall = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    } else if (this.checkedactive === true) {
      this.selctedTickets[0].status = 'Rejected';
      this.selctedTickets[0].loggedinrole = localStorage.getItem('CURRENT_USERROLE_SESSION');
      this.selctedTickets[0].approved_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.selctedTickets[0].updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.selctedTickets[0].update_dt = new Date();

      for (let com of this.selctedTickets) {
        if (!com.comments) {
          this.notificationService.sendNotification(NotificationType.ERROR, "Please enter comments");
          return false;
        }
      }

      this.approvalFlowService.approveRejectWorkflow(this.selctedTickets)
        .subscribe(response => {
          //this.getAllApprovalsData();
          this.notificationService.sendNotification(NotificationType.SUCCESS, "Rejected Successfully");
          this.getApprovalsAppRejData(this.approvalsSearchModel.fromdt, this.approvalsSearchModel.todt);

          this.selctedTickets = [];
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    } else {
      this.notificationService.sendNotification(NotificationType.ERROR, "Please select records");
    }
  }

  update(user: any, values: any) {
    console.log("update() called: " + values.value.currentTarget.checked);
    console.log("update() called: " + user.row);
    if (values.value.currentTarget.checked) {
      this.checkedactive = true;
      this.selctedTickets.push(user.row);
    } else {
      this.checkedactive = false;
      this.selctedTickets.forEach((value: any, index: any) => {
        if (value.id == user.id) this.selctedTickets.splice(index, 1);
      });
    }
    console.log("this.selctedTickets = " + JSON.stringify(this.selctedTickets));
  }

  removeChargeback(user: any, values: any) {
    // console.log(user.row);
    console.log(user.row.disputeType);


    if (user.row.disputeType === "Dispute-Fixed Lines" || user.row.disputeType === "Missing Transaction-Fixed Lines") {
      this.removeStatus = "F";
    } else if (user.row.disputeType === "Dispute-Fixed Lines-Manual") {
      this.removeStatus = "FM";
    } else if (user.row.disputeType === "Dispute-Mobile" || user.row.disputeType === "Missing Transaction-Mobile") {
      this.removeStatus = "M";
    }

    console.log(this.removeStatus);

    if (confirm("Do you want to remove this chargeback?")) {
      console.log(user.row.chargeback_delete_id);
      if (user.row.chargeback_delete_id) {
        this.approvalFlowService.removeChargeback(user.row.chargeback_delete_id, this.removeStatus).subscribe(
          (response: CustomHttpRespone) => {
            this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          }, (errorResponse: HttpErrorResponse) => {
            var msg: any;
            msg = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
          }
        );
      } else {
        console.log("chargeback_delete_id not found. can not delete manual records");
      }
    }
  }





  actionOnButton(action: any) {
    if (action === "Approve") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.approveWorkflow();
      }
    } else if (action === "Reject") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.rejectWorkflow();
      }
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.loadColumnsForDisputeType();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

    this.actionsextracol = [
      {
        name: 'comments',
        dataKey: 'fas fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actions = []

    this.actionButtons = [
      {
        name: 'Approve',
        class: 'btn btn-success btn-xs'
      },
      {
        name: 'Reject',
        class: 'btn btn-danger btn-xs'
      }
    ]
  }

  public exportExcel1() {
    console.log(this.approvalsData);
    this.excelApprovalsData = JSON.parse(JSON.stringify(this.approvalsData));
    console.log(this.excelApprovalsData);
    for (let js of this.excelApprovalsData) {
      delete js.accnum;
      delete js.approved_dt;
      delete js.calRunId;
      delete js.chargeback_delete_id;
      delete js.comm_plan_id;
      delete js.comments;
      delete js.compasID;

      delete js.complanid;
      delete js.complex_kpiid;
      delete js.created_dt;
      delete js.employee_id;
      delete js.final_status;

      delete js.flow_id;
      delete js.id;
      delete js.isValueDisabled;
      delete js.kom_feed_id;
      delete js.loggedin_role;

      delete js.message_content;
      delete js.mob_feed_id;
      delete js.pdt;
      delete js.pending_from_dt;
      delete js.recordType;

      delete js.revenue;
      delete js.sales_channel;
      delete js.sales_rep_id;
      delete js.sc_emp_id;
      delete js.submittedBy;

      delete js.submittedDate;
      delete js.trackingId;
      delete js.tracking_id;
      delete js.workflow_name;

    }
    this.exportExcelService.exportFromJsonRows(this.excelApprovalsData, 'DisputeApprovals');
  }

   viewCommissionReport(event: any) {
    console.log('viewCommissionReport called with event:', event);
    const trackingId = event.trackingId;
    
    if (!trackingId) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'No tracking ID found');
      return;
    }
    
    console.log('Opening modal for tracking ID:', trackingId);
    
    const dialogRef = this.dialog.open(CommissionReportPreviewModalComponent, {
      width: '90%',
      maxHeight: '90vh',
      data: { trackingId: trackingId }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      console.log('Modal closed');
    });
  }

  exportExcel() {
    console.log(this.approvalsData);
    this.excelApprovalsData = JSON.parse(JSON.stringify(this.approvalsData));
    console.log(this.excelApprovalsData);
    for (let js of this.excelApprovalsData) {

      delete js.accnum;
      delete js.approved_dt;
      delete js.calRunId;
      delete js.chargeback_delete_id;
      delete js.comm_plan_id;
      // delete js.comments;
      delete js.compasID;

      delete js.complanid;
      delete js.complex_kpiid;
      delete js.created_dt;
      delete js.employee_id;
      delete js.final_status;

      delete js.flow_id;
      delete js.id;
      delete js.isValueDisabled;
      delete js.kom_feed_id;
      delete js.loggedin_role;

      delete js.message_content;
      delete js.mob_feed_id;
      delete js.pdt;
      delete js.pending_from_dt;
      delete js.recordType;

      delete js.revenue;
      delete js.sales_channel;
      delete js.sales_rep_id;
      delete js.sc_emp_id;
      delete js.submittedBy;

      delete js.submittedDate;
      delete js.trackingId;
      delete js.tracking_id;
      delete js.workflow_name;

      // delete js.created_by;

    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelApprovalsData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'DisputeApprovals',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.ExcelApprovalsData;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

}